/**
 * Predictive Search — Fetch results as user types
 */
(function () {
  'use strict';

  const searchInput = document.querySelector('[data-search-input]');
  const resultsContainer = document.querySelector('[data-search-results]');

  if (!searchInput || !resultsContainer) return;

  let debounceTimer;
  let controller;

  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = searchInput.value.trim();

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(() => fetchResults(query), 300);
  });

  async function fetchResults(query) {
    if (controller) controller.abort();
    controller = new AbortController();

    try {
      const res = await fetch(
        `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=4&section_id=predictive-search`,
        { signal: controller.signal }
      );

      if (!res.ok) return;

      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const results = parsed.querySelector('[data-predictive-search-results]');

      resultsContainer.innerHTML = results ? results.outerHTML : '';
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Predictive search error:', err);
      }
    }
  }
})();
